import { Pipe, PipeTransform, Inject, LOCALE_ID } from "@angular/core";
import { FmsService } from "src/app/services/fms.service";

type CurrencyPosition = "start" | "end" | "none";

@Pipe({
  name: "currencyFormatterPipe",
  standalone: true,
})
export class CurrencyFormatterPipe implements PipeTransform {
  private readonly currency: string;

  constructor(
    private readonly fms: FmsService,
    @Inject(LOCALE_ID) private readonly locale: string, // Inject LOCALE_ID for locale-specific formatting
  ) {
    this.currency = this.fms.instant("pipe.currencyformatter");
  }

  transform<T>(value: string | T, addCurrencyType?: CurrencyPosition, numberOfDecimals = 0): typeof value {
    const numberValidator =
      (typeof value === "number" && !isNaN(value) && isFinite(value)) || (typeof value === "string" && Number(value));

    if (!numberValidator) {
      return value;
    }

    const formattedValue = this.formatNumber(Number(value), numberOfDecimals);

    switch (addCurrencyType) {
      case "start": {
        return `${this.currency} ${formattedValue}`;
      }
      case "end": {
        return `${formattedValue} ${this.currency}`;
      }
      default: {
        return formattedValue;
      }
    }
  }

  private formatNumber(value: number, numberOfDecimals: number): string {
    return new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: numberOfDecimals,
      maximumFractionDigits: numberOfDecimals,
    }).format(value);
  }
}
